// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qkuw","buttons":"styles_buttons__c8_gR"};